// material-ui
import { Box, Typography } from '@mui/material';
// project imports
import menuItem from 'user-menu-items';
import NavGroup from './NavGroup';
import { useGetAdminProfileQuery } from 'lib/api/admin/adminAuthApi';

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
    const { data: profile, isLoading: profileIsLoading } = useGetAdminProfileQuery();

    if (profileIsLoading) return null;

    const getFilteredNavItems = () => {
        if (profile?.data?.id === 100) {
            return menuItem.items
                .filter(
                    (item) =>
                        item.id === 'dashboard' || (item.children && item.children.some((child) => child.id === 'employees-attendance'))
                )
                .map((item) => {
                    if (item.type === 'group') {
                        const specificChild = item.children.find((child) => child.id === 'employees-attendance');
                        const filteredChildren = specificChild ? [specificChild] : item.children;
                        return <NavGroup key={item.id} item={{ ...item, children: filteredChildren }} />;
                    }
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
                });
        }

        return menuItem.items.map((item) =>
            item.type === 'group' ? (
                <NavGroup key={item.id} item={item} />
            ) : (
                <Typography key={item.id} variant="h6" color="error" align="center">
                    Menu Items Error
                </Typography>
            )
        );
    };

    const navItems = getFilteredNavItems();

    return <Box sx={{ mb: 20 }}>{navItems}</Box>;
};

export default MenuList;
